export const environment = {
  production: true,
  apiUrl: "https://backendtest.capitaldivisas.com/api/v1",
  // apiUrl: "http://localhost:3000/api/v1",
  googleClientId: "664009953610-7k9cs9jgjkvmle32sasda02rv2ln8q6k.apps.googleusercontent.com",
  appleClientId: "com.capitaldivisas.web",
  appleRedirectUri: "https://admintest.capitaldivisas.com",
};
